export function changeLanguage(language: string) {
  document.documentElement.setAttribute('lang', language);
}
